import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleBookClick = () => {
    if (window.location.pathname !== '/') {
      navigate('/#booking-form');
    } else {
      let element = document.getElementById('booking-form');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline:'nearest'
        });
      }
    }
  };
  

  return (
    <nav className="bg-blue-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <span className="text-xl font-bold">Riverside Bliss Villa</span>
            </Link>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="hover:text-yellow-300 transition-colors duration-200">Home</Link>
            <Link to="/about" className="hover:text-yellow-300 transition-colors duration-200">About</Link>
            <Link to="/contact" className="hover:text-yellow-300 transition-colors duration-200">Contact</Link>
            <button onClick={handleBookClick} className="bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-bold px-4 py-2 rounded-lg transition-colors duration-200">
              Book Now
            </button>
          </div>
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-yellow-300 focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>
      {isMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <Link to="/" className="block px-3 py-2 rounded-md text-white hover:text-yellow-300">Home</Link>
            <Link to="/about" className="block px-3 py-2 rounded-md text-white hover:text-yellow-300">About</Link>
            <Link to="/contact" className="block px-3 py-2 rounded-md text-white hover:text-yellow-300">Contact</Link>
            <a href="tel:+919400949078" className="block px-3 py-2 rounded-md text-white hover:text-yellow-300">Book Now</a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;